<template>
  <Modal
    class="applyForAddingLabels2"
    title="申请添加标签"
    v-model="show"
    width="700px"
    footer-hide
    @on-cancel="close"
  >
    <div class="body">
      <Form
        ref="ruleFormRef"
        :model="formData"
        :rules="rules"
        :label-width="80"
        inline
      >
        <div>
          <FormItem label="标签分类" prop="labelType">
            <Select v-model="formData.labelType" placeholder="请选择">
              <Option
                v-for="item in labelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></Option>
            </Select>
          </FormItem>
          <FormItem label="标签名称" prop="labelName">
            <Input :maxlength="10" v-model="formData.labelName"></Input>
          </FormItem>
        </div>
        <div>
          <FormItem>
            <Button type="primary" @click="onSubmit">申请添加</Button>
          </FormItem>
        </div>
      </Form>
      <utab
        v-if="value"
        ref="utabRef"
        :baihui-label-type="dicts.BAIHUI_LABEL_TYPE"
      ></utab>
    </div>
  </Modal>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
import utab from "./com/index.vue";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.init();
    },
  },
  components: {
    utab,
  },
  computed: {
    ...mapGetters(["dicts"]),
    labelList() {
      let list = this.dicts.BAIHUI_LABEL_TYPE || [];
      return list.filter((item) => item.string3 != "1");
    },
  },
  data() {
    return {
      show: false,
      formData: {
        labelType: "",
        labelName: "",
      },
      rules: {
        labelType: [
          { required: true, message: "请选择标签分类", trigger: "change" },
        ],
        labelName: [
          { required: true, message: "请输入标签名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    init() {
      this.show = this.value;
      this.$store.dispatch("getWideUseList", "BAIHUI_LABEL_TYPE");
    },
    close() {
      this.$emit("input", false);
    },
    onSubmit() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: "提示",
            content: "确定要申请添加吗？",
            onOk: () => {
              this.postData();
            },
          });
        } else {
          this.$Message.error("请将表单填写完整");
        }
      });
    },
    postData() {
      request.post("/saasbaihui/applyLabel", this.formData).then((res) => {
        this.$Message.success(res.result);
        this.$refs.utabRef.search();
        this.handleReset();
      });
    },
    handleReset() {
      this.$refs.ruleFormRef.resetFields();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss">
.applyForAddingLabels2 {
  .ivu-modal-body {
    padding: 10px;
  }
  .ivu-form .ivu-form-item-label {
    padding-top: 10px;
  }
  .body {
    background: #fff;
    padding: 15px;
    border-radius: 5px;
    .ivu-input-wrapper,
    .ivu-select {
      width: 110px;
    }
    .ivu-input {
      width: 240px;
    }

    .ivu-form {
      // border-bottom: 1px solid #ccc;
      // margin-bottom: 15px;
      justify-content: space-between;
      display: flex;
    }

    .el-form--inline .FormItem {
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>